module.exports = __webpack_public_path__ + "img/lg_ring_r_l_0_null@2x.9617786c.png";